import { defineStore } from "pinia";
import { useUserRoles } from "../assets/js/impactdriver_front/commonComputed";
import {
  fetchMe,
  isFeatureEnabled,
} from "../assets/js/impactdriver_front/requests";

export const useMainStore = defineStore("main", {
  state: () => ({
    allProperties: [],
    allImpactDrivers: [],
    userData: null,
    users: [],
    companies: [],
    activeCycle: null,
    globalSettings: null,
    accountPlans: [],
    companyOutcomes: {},
    impactdriverStatuses: [],
    companiesToShowInTable: [],
    impactDriversToShowInTable: [],
    dataLoadedAt: null,
    companiesRefreshSignal: 0,
    aiChatOpen: false,
    _userDataPromise: null,
    featureFlags: { impactDriversDisabled: false },
    _featureFlagsPromise: null,
  }),

  getters: {
    currency: (state) => state.userData?.organization?.currency || "EUR",
    userIsManagerOrAdmin: (state) => {
      if (!state.userData) return false;
      return useUserRoles(state.userData).userIsManagerOrAdmin.value;
    },
    companiesCount: (state) => state.companies.length,
    impactDriversDisabled: (state) => state.featureFlags.impactDriversDisabled,
  },

  actions: {
    setProperties(properties) {
      this.allProperties = properties;
    },
    setImpactDrivers(drivers) {
      this.allImpactDrivers = drivers;
    },
    setAppData({
      userData,
      users,
      companies,
      activeCycle,
      globalSettings,
      accountPlans,
      companyOutcomes,
      impactdriverStatuses,
      properties,
    }) {
      this.userData = userData;
      this.users = users;
      this.companies = companies;
      this.activeCycle = activeCycle;
      this.globalSettings = globalSettings;
      this.accountPlans = accountPlans;
      this.companyOutcomes = companyOutcomes;
      this.impactdriverStatuses = impactdriverStatuses;
      if (properties) this.allProperties = properties;
      this.dataLoadedAt = new Date();
    },
    requestCompaniesRefresh() {
      this.companiesRefreshSignal++;
    },
    closeAiChat() {
      this.aiChatOpen = false;
    },
    toggleAiChat() {
      this.aiChatOpen = !this.aiChatOpen;
    },
    // One request per page load; every consumer awaits the same promise.
    ensureFeatureFlags() {
      if (this._featureFlagsPromise) return this._featureFlagsPromise;
      this._featureFlagsPromise = isFeatureEnabled("impact_drivers_disabled")
        .then((disabled) => {
          this.featureFlags.impactDriversDisabled = disabled === true;
          return this.featureFlags;
        })
        .catch(() => this.featureFlags);
      return this._featureFlagsPromise;
    },
    async ensureUserData() {
      if (this.userData) return this.userData;
      if (this._userDataPromise) return this._userDataPromise;

      this._userDataPromise = fetchMe()
        .then((me) => {
          this.userData = me;
          return me;
        })
        .finally(() => {
          this._userDataPromise = null;
        });

      return this._userDataPromise;
    },
  },
});
